export const StartEventConfig = {
  width: 40,
  height: 40,
}

export const EndEventConfig = {
  width: 40,
  height: 40,
}

export const BoundaryEventConfig = {
  width: 100,
  height: 80,
}

export const IntermediateEventConfig = {
  width: 100,
  height: 80,
}

export const ParallelGatewayConfig = {
  width: 100,
  height: 80,
}

export const InclusiveGatewayConfig = {
  width: 100,
  height: 80,
}

export const ExclusiveGatewayConfig = {
  width: 100,
  height: 80,
}

export const ServiceTaskConfig = {
  width: 100,
  height: 80,
}

export const UserTaskConfig = {
  width: 100,
  height: 80,
}

export const SubProcessConfig = {
  width: 100,
  height: 80,
}

export const theme = {
  rect: {
    radius: 5,
    stroke: 'rgb(24, 125, 255)',
  },
  circle: {
    r: 18,
    stroke: 'rgb(24, 125, 255)',
  },
  polygon: {
    stroke: 'rgb(24, 125, 255)',
  },
  polyline: {
    stroke: 'rgb(24, 125, 255)',
    hoverStroke: 'rgb(24, 125, 255)',
    selectedStroke: 'rgb(24, 125, 255)',
  },
  edgeText: {
    background: {
      fill: 'white',
      height: 14,
      stroke: 'transparent',
      radius: 3,
    },
  },
}
